// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dashboard-pageContainer-PL4xT {
	width: 100% !important;
	max-width: 100% !important;
	padding: 24px 40px !important;
	margin: 0 !important;
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
	background: #e9f4ff;
	background: rgb(from #e9f4ff, rgb / 30%);
}

.Dashboard-pageContainer-PL4xT .dashBoardGrid {
	display: grid;
	grid-template-columns: 280px minmax(0, 1fr);
	grid-column-gap: 32px;
	width: 100%;

}

.Dashboard-containerResponsive-hN65p {
	max-width: var(--max-content-width);
	margin: 0 auto;
	width: 100%;
	display: block;
}

.Dashboard-slideShow-QFcBY {
	position: relative;
	height: auto;
	width: 100%;
	max-width: 120px;
	margin: 0 auto;
}

.Dashboard-slideShowImages-AeawR {
	list-style: none;
	margin: 0;
	padding: 0;
}

.Dashboard-slideShowImages-AeawR {
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	overflow: hidden;
	background-color: var(--secondary-gray-bg);
}

.Dashboard-imgResponsive-zn7aH {
	width: 100%;
	height: auto;
	border-radius: 50%;
}

.Dashboard-dashBoardSideMenu-FirKY {
	background: var(--background-primary);
	padding: 25px;
	border: 1px solid var(--primary-border);
	border-radius: 8px;
}

.Dashboard-messageCountText-zBJZ0 {
	margin: 0px;
	font-size: 18px;
	font-weight: 600;
	color: var(--primary-foreground);
	font-family: var(--font-family-base) !important;
}

.Dashboard-waveHandImage-dgDsA {
	display: inline-block;
	width: 26px;
	vertical-align: top;
	margin-right: 11px;
}

.Dashboard-waveHandImageSection-FJZXY {
	display: inline-block;
	width: 83%;
	vertical-align: middle;
}

.Dashboard-dashBoardSideMenuBox-jugiZ {
	border: 1px solid var(--primary-border);
	border-radius: 4px;
	padding: 16px 18px;
}

.Dashboard-menuIcons-TSD6v {
	display: table-cell;
	vertical-align: top;
	width: 20px;
	padding-right: 8px;
}

.Dashboard-menuIconsTexts-U6Jt9 {
	display: table-cell;
	width: 91%;
	font-size: 14px;
	line-height: 20px;
	color: var(--primary-foreground);
	font-weight: 500;
}

.Dashboard-pullRight-jNWJY {
	float: right;
}

.Dashboard-noTextDecoration-zpVUM {
	text-decoration: none !important;
}

.Dashboard-reviewHeading-AfBq_ {
	font-size: 16px;
	display: block;
	color: var(--primary-foreground);
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
	border-radius: 8px;
	background: var(--background-primary);
}

.Dashboard-reviewHeading-AfBq_:hover {
	color: var(--primary-foreground);
}

.Dashboard-hr-BXHWR {
	border-top: 1px solid var(--primary-border);
	margin: 20px 0px;
}

.Dashboard-trashIcon-q06xL {
	position: absolute;
	top: 2px;
	right: 2px;
	width: 22px;
	height: 22px;
	background: var(--common-black-primary-bg);
	padding-top: 3px;
	border: 0;
	border-radius: 2px;
	opacity: .9;
	color: var(--common-primary-white-foreground);
	cursor: pointer;
}

.Dashboard-displayFlexIcons-A5pGe {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
}

.Dashboard-profileIcon-DXdPr {
	width: 17px;
	margin: 0px 8px 3px 0px;
}

.Dashboard-menuActive-mQCBf .Dashboard-activBtn-ScIbO {
	background-color: #F8F7FD;
}

.Dashboard-profilePhotoWidth-ubeyW {
	width: 100%;
	position: relative;
	max-width: 253px;
	margin: 0 auto;
}

.Dashboard-photoRemoveText-eqD8I {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	margin-top: 12px;
	font-size: 16px;
	line-height: normal;
	font-weight: 400;
	text-align: center;
}

.Dashboard-photoRemoveText-eqD8I a,
.Dashboard-photoRemoveText-eqD8I a:hover,
.Dashboard-photoRemoveText-eqD8I a:focus {
	color: var(--primary-link-foreground);
	cursor: pointer;
}

/* ============================================================
   HERO BANNER
   ============================================================ */

.Dashboard-heroBanner-eA94Q {
	width: 100%;
	min-height: 150px;
	border-radius: 12px;
	overflow: hidden;
	background-size: cover;
	background-position: center right;
	background-repeat: no-repeat;
	background-color: #daeeff;
	position: relative;
	margin-bottom: 20px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: stretch;
	    -ms-flex-align: stretch;
	        align-items: stretch;
}

.Dashboard-bannerContent-Haywi {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	padding: 20px 24px;
	width: 100%;
	background: -webkit-gradient(linear, left top, right top, color-stop(42%, rgba(218, 238, 255, 0.95)), color-stop(65%, rgba(218, 238, 255, 0.5)), to(rgba(218, 238, 255, 0)));
	background: linear-gradient(to right, rgba(218, 238, 255, 0.95) 42%, rgba(218, 238, 255, 0.5) 65%, rgba(218, 238, 255, 0) 100%);
}

.Dashboard-bannerCharacter-mg3um {
	height: 120px;
	width: auto;
	-ms-flex-negative: 0;
	    flex-shrink: 0;
	margin-right: 20px;
	-webkit-filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));
	        filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));
}

.Dashboard-bannerText-lQVFv {
	-webkit-box-flex: 1;
	    -ms-flex: 1 1;
	        flex: 1 1;
}

.Dashboard-bannerGreeting-qLihE {
	font-family: var(--font-family-base) !important;
	font-size: 28px;
	font-weight: 700;
	color: var(--secondary-oscuro);
	margin: 0 0 4px 0;
	line-height: 1.2;
}

.Dashboard-bannerSubtitle-QfAZI {
	font-family: var(--font-family-base) !important;
	font-size: 14px;
	color: var(--secondary-oscuro);
	margin: 0;
	opacity: 0.85;
}

/* ============================================================
   QUICK LINKS ROW (Mis reservas, Favoritos, Mensajes)
   ============================================================ */

.Dashboard-quickLinksRow-r0aQO {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	gap: 12px;
	margin-bottom: 24px;
}

.Dashboard-quickLinkCard-IaPyL {
	-webkit-box-flex: 1;
	    -ms-flex: 1 1;
	        flex: 1 1;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
	padding: 16px 14px;
	border: 1px solid var(--primary-border);
	border-radius: 10px;
	background: var(--common-white-primary-bg);
	text-decoration: none !important;
	color: var(--primary-foreground);
	-webkit-transition: border-color 0.2s ease, -webkit-box-shadow 0.2s ease;
	transition: border-color 0.2s ease, -webkit-box-shadow 0.2s ease;
	transition: box-shadow 0.2s ease, border-color 0.2s ease;
	transition: box-shadow 0.2s ease, border-color 0.2s ease, -webkit-box-shadow 0.2s ease;
	cursor: pointer;
}

.Dashboard-quickLinkCard-IaPyL:hover {
	-webkit-box-shadow: 0 4px 16px rgba(0, 156, 255, 0.12);
	        box-shadow: 0 4px 16px rgba(0, 156, 255, 0.12);
	border-color: var(--secondary-cielo);
	color: var(--primary-foreground);
}

.Dashboard-quickLinkCardGreen-CrRWH {
	background: #f0fdf8;
}

.Dashboard-quickLinkIconWrap-aoI85 {
	width: 44px;
	height: 44px;
	border-radius: 50%;
	background: #e8f4ff;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}

.Dashboard-quickLinkIconBlue-vNV9j {
	background: #e8f4ff;
}

.Dashboard-quickLinkIconGreen-djIAi {
	background: #d6f5eb;
}

.Dashboard-quickLinkIcon-BKKhI {
	width: 22px;
	height: 22px;
	-o-object-fit: contain;
	   object-fit: contain;
}

.Dashboard-quickLinkInfo-PUYze {
	-webkit-box-flex: 1;
	    -ms-flex: 1 1;
	        flex: 1 1;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	gap: 3px;
}

.Dashboard-quickLinkTitle-eX4U2 {
	font-family: var(--font-family-base) !important;
	font-size: 15px;
	font-weight: 600;
	color: var(--primary-foreground);
}

.Dashboard-quickLinkDesc-w6n5P {
	font-family: var(--font-family-base) !important;
	font-size: 12px;
	color: var(--tertiary-foreground);
	line-height: 1.3;
}

.Dashboard-quickLinkArrow-FoubV {
	width: 16px;
	height: 16px;
	opacity: 0.5;
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}

.Dashboard-quickLinkArrowGreen-Utudd {
	opacity: 0.7;
}

/* ============================================================
   MESSAGES SECTION
   ============================================================ */

.Dashboard-messagesSection-_bpZ0 {
	border: 1px solid var(--primary-border);
	border-radius: 10px;
	padding: 20px;
	background: var(--common-white-primary-bg);
}

.Dashboard-messagesSectionHeader-agRXE {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	margin-bottom: 16px;
}

.Dashboard-viewAllLink-ACLXj {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 4px;
	font-size: 14px;
	font-weight: 500;
	color: var(--primary-link-foreground);
	text-decoration: none !important;
	font-family: var(--font-family-base) !important;
}

.Dashboard-viewAllLink-ACLXj:hover {
	color: var(--primary-bg-hover);
}

.Dashboard-viewAllChevron-tzS6l {
	width: 14px;
	height: 14px;
}

/* ============================================================
   HELP SECTION (¿Necesitas ayuda?)
   ============================================================ */

.Dashboard-helpSection-BAYbq {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 10px;
	margin-top: 16px;
	padding: 14px 16px;
	border: 1px solid var(--primary-border);
	border-radius: 10px;
	background: #d9eafb;
	cursor: pointer;
	-webkit-transition: -webkit-box-shadow 0.2s ease;
	transition: -webkit-box-shadow 0.2s ease;
	transition: box-shadow 0.2s ease;
	transition: box-shadow 0.2s ease, -webkit-box-shadow 0.2s ease;
}

.Dashboard-helpSection-BAYbq:hover {
	-webkit-box-shadow: 0 2px 10px rgba(0, 156, 255, 0.1);
	        box-shadow: 0 2px 10px rgba(0, 156, 255, 0.1);
}

.Dashboard-helpIllustration-xsNNO {
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}

.Dashboard-helpImage-HXesk {
	height: 56px;
	width: auto;
}

.Dashboard-helpContent-MGSXM {
	-webkit-box-flex: 1;
	    -ms-flex: 1 1;
	        flex: 1 1;
}

.Dashboard-helpTitle-Is4NG {
	font-family: var(--font-family-base) !important;
	font-size: 13px;
	font-weight: 600;
	color: var(--primary-foreground);
	margin: 0 0 2px 0;
}

.Dashboard-helpText-T0a_c {
	font-family: var(--font-family-base) !important;
	font-size: 11px;
	color: var(--tertiary-foreground);
	margin: 0;
	line-height: 1.4;
}

.Dashboard-helpArrow-SI9Rk {
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}

.Dashboard-helpChevron-MbCXO {
	width: 14px;
	height: 14px;
	opacity: 0.5;
}

/* ============================================================
   RESPONSIVE
   ============================================================ */

@media screen and (max-width: 991px) {
	.Dashboard-quickLinksRow-r0aQO {
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		    -ms-flex-direction: column;
		        flex-direction: column;
	}

	.Dashboard-heroBanner-eA94Q {
		min-height: 130px;
	}

	.Dashboard-bannerGreeting-qLihE {
		font-size: 22px;
	}

	.Dashboard-bannerCharacter-mg3um {
		height: 90px;
	}
}

@media screen and (max-width: 767px) {
	.Dashboard-menuIconsTexts-U6Jt9 {
		width: 100%;
	}

	.Dashboard-quickLinksRow-r0aQO {
		gap: 8px;
	}
}

/* ============================================================
   LEFT COLUMN WRAPPER
   ============================================================ */

.Dashboard-leftColumn-K2Fc1 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
}

/* ============================================================
   SIDE NAV WRAPPER
   ============================================================ */

.Dashboard-sideNavWrapper-beK85 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	background: transparent;
	gap: 24px;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	height: 100%;
}

/* ============================================================
   SIDE NAV LIST
   ============================================================ */

.Dashboard-sideNavList-B0TAB {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	gap: 4px;
	padding: 0;
	margin: 0;
}

.Dashboard-sideNavItem-ZXHVM {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 14px;
	padding: 12px 16px;
	border-radius: 10px;
	text-decoration: none !important;
	color: #374151;
	font-family: var(--font-family-base) !important;
	font-size: 15px;
	font-weight: 500;
	-webkit-transition: background 0.15s ease, color 0.15s ease;
	transition: background 0.15s ease, color 0.15s ease;
	cursor: pointer;
}

.Dashboard-sideNavItem-ZXHVM:hover {
	background: #d9eafb;
	color: var(--primary-color);
	text-decoration: none !important;
}

.Dashboard-sideNavItemActive-gi2aN {
	background: #d9eafb;
	/* #e9f4ff; */
	color: var(--primary-color);
	font-weight: 600;
}

.Dashboard-sideNavIcon-Dx6lA {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	width: 22px;
	height: 22px;
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}

.Dashboard-sideNavIconImg-LgHnY {
	width: 20px;
	height: 20px;
	-o-object-fit: contain;
	   object-fit: contain;
}

.Dashboard-sideNavLabel-p5Dhn {
	-webkit-box-flex: 1;
	    -ms-flex: 1 1;
	        flex: 1 1;
	white-space: nowrap;
}

/* ============================================================
   HELP SECTION (al pie del menú lateral)
   ============================================================ */

.Dashboard-helpSection-BAYbq {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 10px;
	padding: 14px 14px;
	border: 1px solid #e8ecf2;
	border-radius: 12px;
	background: #eef6ff;
	text-decoration: none !important;
	color: var(--primary-foreground);
	cursor: pointer;
	-webkit-transition: background 0.2s ease, -webkit-box-shadow 0.2s ease;
	transition: background 0.2s ease, -webkit-box-shadow 0.2s ease;
	transition: background 0.2s ease, box-shadow 0.2s ease;
	transition: background 0.2s ease, box-shadow 0.2s ease, -webkit-box-shadow 0.2s ease;
	margin-top: auto;
}

.Dashboard-helpSection-BAYbq:hover {
	background: #eef6ff;
	-webkit-box-shadow: 0 4px 12px rgba(0, 156, 255, 0.08);
	        box-shadow: 0 4px 12px rgba(0, 156, 255, 0.08);
	text-decoration: none !important;
}

.Dashboard-helpIllustration-xsNNO {
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}

.Dashboard-helpImage-HXesk {
	height: 52px;
	width: auto;
}

.Dashboard-helpContent-MGSXM {
	-webkit-box-flex: 1;
	    -ms-flex: 1 1;
	        flex: 1 1;
}

.Dashboard-helpTitle-Is4NG {
	font-family: var(--font-family-base) !important;
	font-size: 13px;
	font-weight: 600;
	color: var(--primary-foreground);
	margin: 0 0 2px 0;
}

.Dashboard-helpText-T0a_c {
	font-family: var(--font-family-base) !important;
	font-size: 11px;
	color: var(--tertiary-foreground);
	margin: 0;
	line-height: 1.4;
}

.Dashboard-helpChevron-MbCXO {
	width: 14px;
	height: 14px;
	opacity: 0.45;
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}

/* ============================================================
   RESPONSIVE
   ============================================================ */

@media screen and (max-width: 991px) {
	.Dashboard-sideNavWrapper-beK85 {
		border-radius: 8px;
	}

	.Dashboard-sideNavList-B0TAB {
		-webkit-box-orient: horizontal;
		-webkit-box-direction: normal;
		    -ms-flex-direction: row;
		        flex-direction: row;
		-ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		padding: 4px 8px;
	}

	.Dashboard-sideNavItem-ZXHVM {
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		    -ms-flex-direction: column;
		        flex-direction: column;
		gap: 4px;
		padding: 10px 14px;
		font-size: 12px;
		border-left: none;
		border-bottom: 3px solid transparent;
		text-align: center;
	}

	.Dashboard-sideNavItemActive-gi2aN {
		border-left-color: transparent;
		border-bottom-color: var(--primary-color);
	}
}

/* ============================================================
   RIGHT COLUMN — contenido principal
   ============================================================ */

.Dashboard-rightColumn-jvjCp {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	gap: 0;
	min-width: 0;
}

/* ============================================================
   BELOW BANNER GRID — foto+info | accesos+mensajes
   ============================================================ */

.Dashboard-belowBannerGrid-nZ3al {
	display: grid;
	grid-template-columns: 380px 1fr;
	grid-column-gap: 24px;
	-webkit-box-align: start;
	    -ms-flex-align: start;
	        align-items: start;
	margin-top: 20px;
}

.Dashboard-profileColumn-zjdP5 {
	min-width: 0;
}

.Dashboard-mainColumn-Vg5kB {
	min-width: 0;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	gap: 0;
}

/* En el contexto del sub-grid, el quickLinksRow ya no necesita
   colapsar en columna en tablet porque ya tiene menos ancho */

.Dashboard-mainColumn-Vg5kB .Dashboard-quickLinksRow-r0aQO {
	-webkit-box-orient: horizontal;
	-webkit-box-direction: normal;
	    -ms-flex-direction: row;
	        flex-direction: row;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

/* ============================================================
   RESPONSIVE — belowBannerGrid
   ============================================================ */

@media screen and (max-width: 1100px) {
	.Dashboard-belowBannerGrid-nZ3al {
		grid-template-columns: 240px 1fr;
		grid-column-gap: 16px;
	}
}

@media screen and (max-width: 900px) {
	.Dashboard-belowBannerGrid-nZ3al {
		grid-template-columns: 1fr;
		grid-row-gap: 20px;
	}

	.Dashboard-pageContainer-PL4xT {
		padding: 20px 16px;
	}
}

/* ============================================================
   PROFILE USER INFO (Name & Location under photo)
   ============================================================ */

.Dashboard-profileUserInfo-_gVS9 {
	margin-top: 14px;
	text-align: left;
}

.Dashboard-profileUserName-Orbgt {
	font-family: var(--font-family-base) !important;
	font-size: 20px;
	font-weight: 700;
	color: var(--primary-foreground);
	margin: 0 0 6px 0;
	line-height: 1.2;
}

.Dashboard-profileUserLocation-XYGj8 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 6px;
	font-family: var(--font-family-base) !important;
	font-size: 13px;
	color: var(--secondary-foreground);
}

.Dashboard-profileLocationPin-EIu0W {
	width: 14px;
	height: 14px;
	opacity: 0.7;
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}

/* ============================================================
   DASHBOARD NOTE CARD
   ============================================================ */

.Dashboard-dashboardNoteCard-a_HdL {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: start;
	    -ms-flex-align: start;
	        align-items: flex-start;
	gap: 16px;
	padding: 18px 22px;
	border: 1px solid var(--primary-border);
	border-radius: 12px;
	background: var(--tertiary-gray-bg);
	margin-bottom: 20px;
	-webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
	        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.Dashboard-dashboardNoteIconWrap-PTJ5E {
	width: 42px;
	height: 42px;
	border-radius: 50%;
	background: var(--primary-color-suave);
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-ms-flex-negative: 0;
	    flex-shrink: 0;
	margin-top: 2px;
}

.Dashboard-dashboardNoteIcon-zYr33 {
	width: 24px;
	height: 24px;
	-o-object-fit: contain;
	   object-fit: contain;
}

.Dashboard-dashboardNoteContent-hcNLh {
	-webkit-box-flex: 1;
	    -ms-flex: 1 1;
	        flex: 1 1;
}

.Dashboard-dashboardNoteTitle-gtohv {
	font-family: var(--font-family-base) !important;
	font-size: 16px;
	font-weight: 700;
	color: var(--secondary-oscuro);
	margin: 0 0 6px 0;
	line-height: 1.3;
}

.Dashboard-dashboardNoteText-ZboyH {
	font-family: var(--font-family-base) !important;
	font-size: 13.5px;
	line-height: 1.55;
	color: var(--secondary-foreground);
	margin: 0;
}

.Dashboard-dashboardNoteGreetingBold-QrBTz {
	font-weight: 700;
	color: var(--primary-foreground);
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;CACC,sBAAsB;CACtB,0BAA0B;CAC1B,6BAA6B;CAC7B,oBAAoB;CACpB,8BAAsB;SAAtB,sBAAsB;CACtB,mBAAmB;CACnB,wCAAwC;AACzC;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;CACrB,WAAW;;AAEZ;;AAEA;CACC,mCAAmC;CACnC,cAAc;CACd,WAAW;CACX,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,gBAAgB;CAChB,0CAA0C;AAC3C;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,qCAAqC;CACrC,aAAa;CACb,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,gCAAgC;CAChC,+CAA+C;AAChD;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,UAAU;CACV,eAAe;CACf,iBAAiB;CACjB,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gCAAgC;CAChC,kBAAkB;CAClB,uCAAuC;CACvC,kBAAkB;CAClB,qCAAqC;AACtC;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,WAAW;CACX,YAAY;CACZ,0CAA0C;CAC1C,gBAAgB;CAChB,SAAS;CACT,kBAAkB;CAClB,WAAW;CACX,6CAA6C;CAC7C,eAAe;AAChB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;AAC/B;;AAEA;CACC,WAAW;CACX,uBAAuB;AACxB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,gBAAgB;CAChB,eAAe;CACf,mBAAmB;CACnB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;;;CAGC,qCAAqC;CACrC,eAAe;AAChB;;AAEA;;iEAEiE;;AAEjE;CACC,WAAW;CACX,iBAAiB;CACjB,mBAAmB;CACnB,gBAAgB;CAChB,sBAAsB;CACtB,iCAAiC;CACjC,4BAA4B;CAC5B,yBAAyB;CACzB,kBAAkB;CAClB,mBAAmB;CACnB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,0BAAoB;KAApB,uBAAoB;SAApB,oBAAoB;AACrB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,kBAAkB;CAClB,WAAW;CACX,4KAA+H;CAA/H,+HAA+H;AAChI;;AAEA;CACC,aAAa;CACb,WAAW;CACX,oBAAc;KAAd,cAAc;CACd,kBAAkB;CAClB,yDAAiD;SAAjD,iDAAiD;AAClD;;AAEA;CACC,mBAAO;KAAP,aAAO;SAAP,SAAO;AACR;;AAEA;CACC,+CAA+C;CAC/C,eAAe;CACf,gBAAgB;CAChB,8BAA8B;CAC9B,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,+CAA+C;CAC/C,eAAe;CACf,8BAA8B;CAC9B,SAAS;CACT,aAAa;AACd;;AAEA;;iEAEiE;;AAEjE;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,SAAS;CACT,mBAAmB;AACpB;;AAEA;CACC,mBAAO;KAAP,aAAO;SAAP,SAAO;CACP,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;CACT,kBAAkB;CAClB,uCAAuC;CACvC,mBAAmB;CACnB,0CAA0C;CAC1C,gCAAgC;CAChC,gCAAgC;CAChC,wEAAwD;CAAxD,gEAAwD;CAAxD,wDAAwD;CAAxD,sFAAwD;CACxD,eAAe;AAChB;;AAEA;CACC,sDAA8C;SAA9C,8CAA8C;CAC9C,oCAAoC;CACpC,gCAAgC;AACjC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,oBAAc;KAAd,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,sBAAmB;IAAnB,mBAAmB;AACpB;;AAEA;CACC,mBAAO;KAAP,aAAO;SAAP,SAAO;CACP,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,+CAA+C;CAC/C,eAAe;CACf,gBAAgB;CAChB,gCAAgC;AACjC;;AAEA;CACC,+CAA+C;CAC/C,eAAe;CACf,iCAAiC;CACjC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,oBAAc;KAAd,cAAc;AACf;;AAEA;CACC,YAAY;AACb;;AAEA;;iEAEiE;;AAEjE;CACC,uCAAuC;CACvC,mBAAmB;CACnB,aAAa;CACb,0CAA0C;AAC3C;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,eAAe;CACf,gBAAgB;CAChB,qCAAqC;CACrC,gCAAgC;CAChC,+CAA+C;AAChD;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;;iEAEiE;;AAEjE;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;CACT,gBAAgB;CAChB,kBAAkB;CAClB,uCAAuC;CACvC,mBAAmB;CACnB,mBAAmB;CACnB,eAAe;CACf,gDAAgC;CAAhC,wCAAgC;CAAhC,gCAAgC;CAAhC,8DAAgC;AACjC;;AAEA;CACC,qDAA6C;SAA7C,6CAA6C;AAC9C;;AAEA;CACC,oBAAc;KAAd,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,mBAAO;KAAP,aAAO;SAAP,SAAO;AACR;;AAEA;CACC,+CAA+C;CAC/C,eAAe;CACf,gBAAgB;CAChB,gCAAgC;CAChC,iBAAiB;AAClB;;AAEA;CACC,+CAA+C;CAC/C,eAAe;CACf,iCAAiC;CACjC,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,oBAAc;KAAd,cAAc;AACf;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,YAAY;AACb;;AAEA;;iEAEiE;;AAEjE;CACC;EACC,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;CACvB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,YAAY;CACb;AACD;;AAEA;CACC;EACC,WAAW;CACZ;;CAEA;EACC,QAAQ;CACT;AACD;;AAEA;;iEAEiE;;AAEjE;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;AACvB;;AAEA;;iEAEiE;;AAEjE;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,uBAAuB;CACvB,SAAS;CACT,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,YAAY;AACb;;AAEA;;iEAEiE;;AAEjE;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,QAAQ;CACR,UAAU;CACV,SAAS;AACV;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;CACT,kBAAkB;CAClB,mBAAmB;CACnB,gCAAgC;CAChC,cAAc;CACd,+CAA+C;CAC/C,eAAe;CACf,gBAAgB;CAChB,2DAAmD;CAAnD,mDAAmD;CACnD,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,2BAA2B;CAC3B,gCAAgC;AACjC;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,2BAA2B;CAC3B,gBAAgB;AACjB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,WAAW;CACX,YAAY;CACZ,oBAAc;KAAd,cAAc;AACf;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,sBAAmB;IAAnB,mBAAmB;AACpB;;AAEA;CACC,mBAAO;KAAP,aAAO;SAAP,SAAO;CACP,mBAAmB;AACpB;;AAEA;;iEAEiE;;AAEjE;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;CACT,kBAAkB;CAClB,yBAAyB;CACzB,mBAAmB;CACnB,mBAAmB;CACnB,gCAAgC;CAChC,gCAAgC;CAChC,eAAe;CACf,sEAAsD;CAAtD,8DAAsD;CAAtD,sDAAsD;CAAtD,oFAAsD;CACtD,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,sDAA8C;SAA9C,8CAA8C;CAC9C,gCAAgC;AACjC;;AAGA;CACC,oBAAc;KAAd,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,mBAAO;KAAP,aAAO;SAAP,SAAO;AACR;;AAEA;CACC,+CAA+C;CAC/C,eAAe;CACf,gBAAgB;CAChB,gCAAgC;CAChC,iBAAiB;AAClB;;AAEA;CACC,+CAA+C;CAC/C,eAAe;CACf,iCAAiC;CACjC,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,oBAAc;KAAd,cAAc;AACf;;AAEA;;iEAEiE;;AAEjE;CACC;EACC,kBAAkB;CACnB;;CAEA;EACC,8BAAmB;EAAnB,6BAAmB;MAAnB,uBAAmB;UAAnB,mBAAmB;EACnB,mBAAe;MAAf,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;CACnB;;CAEA;EACC,8BAA8B;EAC9B,yCAAyC;CAC1C;AACD;;AAEA;;iEAEiE;;AAEjE;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,MAAM;CACN,YAAY;AACb;;AAEA;;iEAEiE;;AAEjE;CACC,aAAa;CACb,gCAAgC;CAChC,qBAAqB;CACrB,wBAAkB;KAAlB,qBAAkB;SAAlB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,MAAM;AACP;;AAEA;8DAC8D;;AAC9D;CACC,8BAAmB;CAAnB,6BAAmB;KAAnB,uBAAmB;SAAnB,mBAAmB;CACnB,mBAAe;KAAf,eAAe;AAChB;;AAEA;;iEAEiE;;AAEjE;CACC;EACC,gCAAgC;EAChC,qBAAqB;CACtB;AACD;;AAEA;CACC;EACC,0BAA0B;EAC1B,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;AACD;;AAEA;;iEAEiE;;AAEjE;CACC,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,+CAA+C;CAC/C,eAAe;CACf,gBAAgB;CAChB,gCAAgC;CAChC,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,+CAA+C;CAC/C,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,oBAAc;KAAd,cAAc;AACf;;AAEA;;iEAEiE;;AAEjE;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,SAAS;CACT,kBAAkB;CAClB,uCAAuC;CACvC,mBAAmB;CACnB,mCAAmC;CACnC,mBAAmB;CACnB,iDAAyC;SAAzC,yCAAyC;AAC1C;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,sCAAsC;CACtC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,oBAAc;KAAd,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,sBAAmB;IAAnB,mBAAmB;AACpB;;AAEA;CACC,mBAAO;KAAP,aAAO;SAAP,SAAO;AACR;;AAEA;CACC,+CAA+C;CAC/C,eAAe;CACf,gBAAgB;CAChB,8BAA8B;CAC9B,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,+CAA+C;CAC/C,iBAAiB;CACjB,iBAAiB;CACjB,kCAAkC;CAClC,SAAS;AACV;;AAEA;CACC,gBAAgB;CAChB,gCAAgC;AACjC","sourcesContent":[".pageContainer {\n\twidth: 100% !important;\n\tmax-width: 100% !important;\n\tpadding: 24px 40px !important;\n\tmargin: 0 !important;\n\tbox-sizing: border-box;\n\tbackground: #e9f4ff;\n\tbackground: rgb(from #e9f4ff, rgb / 30%);\n}\n\n.pageContainer :global(.dashBoardGrid) {\n\tdisplay: grid;\n\tgrid-template-columns: 280px minmax(0, 1fr);\n\tgrid-column-gap: 32px;\n\twidth: 100%;\n\n}\n\n.containerResponsive {\n\tmax-width: var(--max-content-width);\n\tmargin: 0 auto;\n\twidth: 100%;\n\tdisplay: block;\n}\n\n.slideShow {\n\tposition: relative;\n\theight: auto;\n\twidth: 100%;\n\tmax-width: 120px;\n\tmargin: 0 auto;\n}\n\n.slideShowImages {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n}\n\n.slideShowImages {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\toverflow: hidden;\n\tbackground-color: var(--secondary-gray-bg);\n}\n\n.imgResponsive {\n\twidth: 100%;\n\theight: auto;\n\tborder-radius: 50%;\n}\n\n.dashBoardSideMenu {\n\tbackground: var(--background-primary);\n\tpadding: 25px;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 8px;\n}\n\n.messageCountText {\n\tmargin: 0px;\n\tfont-size: 18px;\n\tfont-weight: 600;\n\tcolor: var(--primary-foreground);\n\tfont-family: var(--font-family-base) !important;\n}\n\n.waveHandImage {\n\tdisplay: inline-block;\n\twidth: 26px;\n\tvertical-align: top;\n\tmargin-right: 11px;\n}\n\n.waveHandImageSection {\n\tdisplay: inline-block;\n\twidth: 83%;\n\tvertical-align: middle;\n}\n\n.dashBoardSideMenuBox {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 4px;\n\tpadding: 16px 18px;\n}\n\n.menuIcons {\n\tdisplay: table-cell;\n\tvertical-align: top;\n\twidth: 20px;\n\tpadding-right: 8px;\n}\n\n.menuIconsTexts {\n\tdisplay: table-cell;\n\twidth: 91%;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: var(--primary-foreground);\n\tfont-weight: 500;\n}\n\n.pullRight {\n\tfloat: right;\n}\n\n.noTextDecoration {\n\ttext-decoration: none !important;\n}\n\n.reviewHeading {\n\tfont-size: 16px;\n\tdisplay: block;\n\tcolor: var(--primary-foreground);\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 8px;\n\tbackground: var(--background-primary);\n}\n\n.reviewHeading:hover {\n\tcolor: var(--primary-foreground);\n}\n\n.hr {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 20px 0px;\n}\n\n.trashIcon {\n\tposition: absolute;\n\ttop: 2px;\n\tright: 2px;\n\twidth: 22px;\n\theight: 22px;\n\tbackground: var(--common-black-primary-bg);\n\tpadding-top: 3px;\n\tborder: 0;\n\tborder-radius: 2px;\n\topacity: .9;\n\tcolor: var(--common-primary-white-foreground);\n\tcursor: pointer;\n}\n\n.displayFlexIcons {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.profileIcon {\n\twidth: 17px;\n\tmargin: 0px 8px 3px 0px;\n}\n\n.menuActive .activBtn {\n\tbackground-color: #F8F7FD;\n}\n\n.profilePhotoWidth {\n\twidth: 100%;\n\tposition: relative;\n\tmax-width: 253px;\n\tmargin: 0 auto;\n}\n\n.photoRemoveText {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-top: 12px;\n\tfont-size: 16px;\n\tline-height: normal;\n\tfont-weight: 400;\n\ttext-align: center;\n}\n\n.photoRemoveText a,\n.photoRemoveText a:hover,\n.photoRemoveText a:focus {\n\tcolor: var(--primary-link-foreground);\n\tcursor: pointer;\n}\n\n/* ============================================================\n   HERO BANNER\n   ============================================================ */\n\n.heroBanner {\n\twidth: 100%;\n\tmin-height: 150px;\n\tborder-radius: 12px;\n\toverflow: hidden;\n\tbackground-size: cover;\n\tbackground-position: center right;\n\tbackground-repeat: no-repeat;\n\tbackground-color: #daeeff;\n\tposition: relative;\n\tmargin-bottom: 20px;\n\tdisplay: flex;\n\talign-items: stretch;\n}\n\n.bannerContent {\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 20px 24px;\n\twidth: 100%;\n\tbackground: linear-gradient(to right, rgba(218, 238, 255, 0.95) 42%, rgba(218, 238, 255, 0.5) 65%, rgba(218, 238, 255, 0) 100%);\n}\n\n.bannerCharacter {\n\theight: 120px;\n\twidth: auto;\n\tflex-shrink: 0;\n\tmargin-right: 20px;\n\tfilter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));\n}\n\n.bannerText {\n\tflex: 1;\n}\n\n.bannerGreeting {\n\tfont-family: var(--font-family-base) !important;\n\tfont-size: 28px;\n\tfont-weight: 700;\n\tcolor: var(--secondary-oscuro);\n\tmargin: 0 0 4px 0;\n\tline-height: 1.2;\n}\n\n.bannerSubtitle {\n\tfont-family: var(--font-family-base) !important;\n\tfont-size: 14px;\n\tcolor: var(--secondary-oscuro);\n\tmargin: 0;\n\topacity: 0.85;\n}\n\n/* ============================================================\n   QUICK LINKS ROW (Mis reservas, Favoritos, Mensajes)\n   ============================================================ */\n\n.quickLinksRow {\n\tdisplay: flex;\n\tgap: 12px;\n\tmargin-bottom: 24px;\n}\n\n.quickLinkCard {\n\tflex: 1;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n\tpadding: 16px 14px;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 10px;\n\tbackground: var(--common-white-primary-bg);\n\ttext-decoration: none !important;\n\tcolor: var(--primary-foreground);\n\ttransition: box-shadow 0.2s ease, border-color 0.2s ease;\n\tcursor: pointer;\n}\n\n.quickLinkCard:hover {\n\tbox-shadow: 0 4px 16px rgba(0, 156, 255, 0.12);\n\tborder-color: var(--secondary-cielo);\n\tcolor: var(--primary-foreground);\n}\n\n.quickLinkCardGreen {\n\tbackground: #f0fdf8;\n}\n\n.quickLinkIconWrap {\n\twidth: 44px;\n\theight: 44px;\n\tborder-radius: 50%;\n\tbackground: #e8f4ff;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-shrink: 0;\n}\n\n.quickLinkIconBlue {\n\tbackground: #e8f4ff;\n}\n\n.quickLinkIconGreen {\n\tbackground: #d6f5eb;\n}\n\n.quickLinkIcon {\n\twidth: 22px;\n\theight: 22px;\n\tobject-fit: contain;\n}\n\n.quickLinkInfo {\n\tflex: 1;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 3px;\n}\n\n.quickLinkTitle {\n\tfont-family: var(--font-family-base) !important;\n\tfont-size: 15px;\n\tfont-weight: 600;\n\tcolor: var(--primary-foreground);\n}\n\n.quickLinkDesc {\n\tfont-family: var(--font-family-base) !important;\n\tfont-size: 12px;\n\tcolor: var(--tertiary-foreground);\n\tline-height: 1.3;\n}\n\n.quickLinkArrow {\n\twidth: 16px;\n\theight: 16px;\n\topacity: 0.5;\n\tflex-shrink: 0;\n}\n\n.quickLinkArrowGreen {\n\topacity: 0.7;\n}\n\n/* ============================================================\n   MESSAGES SECTION\n   ============================================================ */\n\n.messagesSection {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 10px;\n\tpadding: 20px;\n\tbackground: var(--common-white-primary-bg);\n}\n\n.messagesSectionHeader {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-bottom: 16px;\n}\n\n.viewAllLink {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 4px;\n\tfont-size: 14px;\n\tfont-weight: 500;\n\tcolor: var(--primary-link-foreground);\n\ttext-decoration: none !important;\n\tfont-family: var(--font-family-base) !important;\n}\n\n.viewAllLink:hover {\n\tcolor: var(--primary-bg-hover);\n}\n\n.viewAllChevron {\n\twidth: 14px;\n\theight: 14px;\n}\n\n/* ============================================================\n   HELP SECTION (¿Necesitas ayuda?)\n   ============================================================ */\n\n.helpSection {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n\tmargin-top: 16px;\n\tpadding: 14px 16px;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 10px;\n\tbackground: #d9eafb;\n\tcursor: pointer;\n\ttransition: box-shadow 0.2s ease;\n}\n\n.helpSection:hover {\n\tbox-shadow: 0 2px 10px rgba(0, 156, 255, 0.1);\n}\n\n.helpIllustration {\n\tflex-shrink: 0;\n}\n\n.helpImage {\n\theight: 56px;\n\twidth: auto;\n}\n\n.helpContent {\n\tflex: 1;\n}\n\n.helpTitle {\n\tfont-family: var(--font-family-base) !important;\n\tfont-size: 13px;\n\tfont-weight: 600;\n\tcolor: var(--primary-foreground);\n\tmargin: 0 0 2px 0;\n}\n\n.helpText {\n\tfont-family: var(--font-family-base) !important;\n\tfont-size: 11px;\n\tcolor: var(--tertiary-foreground);\n\tmargin: 0;\n\tline-height: 1.4;\n}\n\n.helpArrow {\n\tflex-shrink: 0;\n}\n\n.helpChevron {\n\twidth: 14px;\n\theight: 14px;\n\topacity: 0.5;\n}\n\n/* ============================================================\n   RESPONSIVE\n   ============================================================ */\n\n@media screen and (max-width: 991px) {\n\t.quickLinksRow {\n\t\tflex-direction: column;\n\t}\n\n\t.heroBanner {\n\t\tmin-height: 130px;\n\t}\n\n\t.bannerGreeting {\n\t\tfont-size: 22px;\n\t}\n\n\t.bannerCharacter {\n\t\theight: 90px;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.menuIconsTexts {\n\t\twidth: 100%;\n\t}\n\n\t.quickLinksRow {\n\t\tgap: 8px;\n\t}\n}\n\n/* ============================================================\n   LEFT COLUMN WRAPPER\n   ============================================================ */\n\n.leftColumn {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n/* ============================================================\n   SIDE NAV WRAPPER\n   ============================================================ */\n\n.sideNavWrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground: transparent;\n\tgap: 24px;\n\tjustify-content: space-between;\n\theight: 100%;\n}\n\n/* ============================================================\n   SIDE NAV LIST\n   ============================================================ */\n\n.sideNavList {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 4px;\n\tpadding: 0;\n\tmargin: 0;\n}\n\n.sideNavItem {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 14px;\n\tpadding: 12px 16px;\n\tborder-radius: 10px;\n\ttext-decoration: none !important;\n\tcolor: #374151;\n\tfont-family: var(--font-family-base) !important;\n\tfont-size: 15px;\n\tfont-weight: 500;\n\ttransition: background 0.15s ease, color 0.15s ease;\n\tcursor: pointer;\n}\n\n.sideNavItem:hover {\n\tbackground: #d9eafb;\n\tcolor: var(--primary-color);\n\ttext-decoration: none !important;\n}\n\n.sideNavItemActive {\n\tbackground: #d9eafb;\n\t/* #e9f4ff; */\n\tcolor: var(--primary-color);\n\tfont-weight: 600;\n}\n\n.sideNavIcon {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 22px;\n\theight: 22px;\n\tflex-shrink: 0;\n}\n\n.sideNavIconImg {\n\twidth: 20px;\n\theight: 20px;\n\tobject-fit: contain;\n}\n\n.sideNavLabel {\n\tflex: 1;\n\twhite-space: nowrap;\n}\n\n/* ============================================================\n   HELP SECTION (al pie del menú lateral)\n   ============================================================ */\n\n.helpSection {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n\tpadding: 14px 14px;\n\tborder: 1px solid #e8ecf2;\n\tborder-radius: 12px;\n\tbackground: #eef6ff;\n\ttext-decoration: none !important;\n\tcolor: var(--primary-foreground);\n\tcursor: pointer;\n\ttransition: background 0.2s ease, box-shadow 0.2s ease;\n\tmargin-top: auto;\n}\n\n.helpSection:hover {\n\tbackground: #eef6ff;\n\tbox-shadow: 0 4px 12px rgba(0, 156, 255, 0.08);\n\ttext-decoration: none !important;\n}\n\n\n.helpIllustration {\n\tflex-shrink: 0;\n}\n\n.helpImage {\n\theight: 52px;\n\twidth: auto;\n}\n\n.helpContent {\n\tflex: 1;\n}\n\n.helpTitle {\n\tfont-family: var(--font-family-base) !important;\n\tfont-size: 13px;\n\tfont-weight: 600;\n\tcolor: var(--primary-foreground);\n\tmargin: 0 0 2px 0;\n}\n\n.helpText {\n\tfont-family: var(--font-family-base) !important;\n\tfont-size: 11px;\n\tcolor: var(--tertiary-foreground);\n\tmargin: 0;\n\tline-height: 1.4;\n}\n\n.helpChevron {\n\twidth: 14px;\n\theight: 14px;\n\topacity: 0.45;\n\tflex-shrink: 0;\n}\n\n/* ============================================================\n   RESPONSIVE\n   ============================================================ */\n\n@media screen and (max-width: 991px) {\n\t.sideNavWrapper {\n\t\tborder-radius: 8px;\n\t}\n\n\t.sideNavList {\n\t\tflex-direction: row;\n\t\tflex-wrap: wrap;\n\t\tpadding: 4px 8px;\n\t}\n\n\t.sideNavItem {\n\t\tflex-direction: column;\n\t\tgap: 4px;\n\t\tpadding: 10px 14px;\n\t\tfont-size: 12px;\n\t\tborder-left: none;\n\t\tborder-bottom: 3px solid transparent;\n\t\ttext-align: center;\n\t}\n\n\t.sideNavItemActive {\n\t\tborder-left-color: transparent;\n\t\tborder-bottom-color: var(--primary-color);\n\t}\n}\n\n/* ============================================================\n   RIGHT COLUMN — contenido principal\n   ============================================================ */\n\n.rightColumn {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0;\n\tmin-width: 0;\n}\n\n/* ============================================================\n   BELOW BANNER GRID — foto+info | accesos+mensajes\n   ============================================================ */\n\n.belowBannerGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 380px 1fr;\n\tgrid-column-gap: 24px;\n\talign-items: start;\n\tmargin-top: 20px;\n}\n\n.profileColumn {\n\tmin-width: 0;\n}\n\n.mainColumn {\n\tmin-width: 0;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0;\n}\n\n/* En el contexto del sub-grid, el quickLinksRow ya no necesita\n   colapsar en columna en tablet porque ya tiene menos ancho */\n.mainColumn .quickLinksRow {\n\tflex-direction: row;\n\tflex-wrap: wrap;\n}\n\n/* ============================================================\n   RESPONSIVE — belowBannerGrid\n   ============================================================ */\n\n@media screen and (max-width: 1100px) {\n\t.belowBannerGrid {\n\t\tgrid-template-columns: 240px 1fr;\n\t\tgrid-column-gap: 16px;\n\t}\n}\n\n@media screen and (max-width: 900px) {\n\t.belowBannerGrid {\n\t\tgrid-template-columns: 1fr;\n\t\tgrid-row-gap: 20px;\n\t}\n\n\t.pageContainer {\n\t\tpadding: 20px 16px;\n\t}\n}\n\n/* ============================================================\n   PROFILE USER INFO (Name & Location under photo)\n   ============================================================ */\n\n.profileUserInfo {\n\tmargin-top: 14px;\n\ttext-align: left;\n}\n\n.profileUserName {\n\tfont-family: var(--font-family-base) !important;\n\tfont-size: 20px;\n\tfont-weight: 700;\n\tcolor: var(--primary-foreground);\n\tmargin: 0 0 6px 0;\n\tline-height: 1.2;\n}\n\n.profileUserLocation {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 6px;\n\tfont-family: var(--font-family-base) !important;\n\tfont-size: 13px;\n\tcolor: var(--secondary-foreground);\n}\n\n.profileLocationPin {\n\twidth: 14px;\n\theight: 14px;\n\topacity: 0.7;\n\tflex-shrink: 0;\n}\n\n/* ============================================================\n   DASHBOARD NOTE CARD\n   ============================================================ */\n\n.dashboardNoteCard {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tgap: 16px;\n\tpadding: 18px 22px;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 12px;\n\tbackground: var(--tertiary-gray-bg);\n\tmargin-bottom: 20px;\n\tbox-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.dashboardNoteIconWrap {\n\twidth: 42px;\n\theight: 42px;\n\tborder-radius: 50%;\n\tbackground: var(--primary-color-suave);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-shrink: 0;\n\tmargin-top: 2px;\n}\n\n.dashboardNoteIcon {\n\twidth: 24px;\n\theight: 24px;\n\tobject-fit: contain;\n}\n\n.dashboardNoteContent {\n\tflex: 1;\n}\n\n.dashboardNoteTitle {\n\tfont-family: var(--font-family-base) !important;\n\tfont-size: 16px;\n\tfont-weight: 700;\n\tcolor: var(--secondary-oscuro);\n\tmargin: 0 0 6px 0;\n\tline-height: 1.3;\n}\n\n.dashboardNoteText {\n\tfont-family: var(--font-family-base) !important;\n\tfont-size: 13.5px;\n\tline-height: 1.55;\n\tcolor: var(--secondary-foreground);\n\tmargin: 0;\n}\n\n.dashboardNoteGreetingBold {\n\tfont-weight: 700;\n\tcolor: var(--primary-foreground);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `Dashboard-pageContainer-PL4xT`,
	"containerResponsive": `Dashboard-containerResponsive-hN65p`,
	"slideShow": `Dashboard-slideShow-QFcBY`,
	"slideShowImages": `Dashboard-slideShowImages-AeawR`,
	"imgResponsive": `Dashboard-imgResponsive-zn7aH`,
	"dashBoardSideMenu": `Dashboard-dashBoardSideMenu-FirKY`,
	"messageCountText": `Dashboard-messageCountText-zBJZ0`,
	"waveHandImage": `Dashboard-waveHandImage-dgDsA`,
	"waveHandImageSection": `Dashboard-waveHandImageSection-FJZXY`,
	"dashBoardSideMenuBox": `Dashboard-dashBoardSideMenuBox-jugiZ`,
	"menuIcons": `Dashboard-menuIcons-TSD6v`,
	"menuIconsTexts": `Dashboard-menuIconsTexts-U6Jt9`,
	"pullRight": `Dashboard-pullRight-jNWJY`,
	"noTextDecoration": `Dashboard-noTextDecoration-zpVUM`,
	"reviewHeading": `Dashboard-reviewHeading-AfBq_`,
	"hr": `Dashboard-hr-BXHWR`,
	"trashIcon": `Dashboard-trashIcon-q06xL`,
	"displayFlexIcons": `Dashboard-displayFlexIcons-A5pGe`,
	"profileIcon": `Dashboard-profileIcon-DXdPr`,
	"menuActive": `Dashboard-menuActive-mQCBf`,
	"activBtn": `Dashboard-activBtn-ScIbO`,
	"profilePhotoWidth": `Dashboard-profilePhotoWidth-ubeyW`,
	"photoRemoveText": `Dashboard-photoRemoveText-eqD8I`,
	"heroBanner": `Dashboard-heroBanner-eA94Q`,
	"bannerContent": `Dashboard-bannerContent-Haywi`,
	"bannerCharacter": `Dashboard-bannerCharacter-mg3um`,
	"bannerText": `Dashboard-bannerText-lQVFv`,
	"bannerGreeting": `Dashboard-bannerGreeting-qLihE`,
	"bannerSubtitle": `Dashboard-bannerSubtitle-QfAZI`,
	"quickLinksRow": `Dashboard-quickLinksRow-r0aQO`,
	"quickLinkCard": `Dashboard-quickLinkCard-IaPyL`,
	"quickLinkCardGreen": `Dashboard-quickLinkCardGreen-CrRWH`,
	"quickLinkIconWrap": `Dashboard-quickLinkIconWrap-aoI85`,
	"quickLinkIconBlue": `Dashboard-quickLinkIconBlue-vNV9j`,
	"quickLinkIconGreen": `Dashboard-quickLinkIconGreen-djIAi`,
	"quickLinkIcon": `Dashboard-quickLinkIcon-BKKhI`,
	"quickLinkInfo": `Dashboard-quickLinkInfo-PUYze`,
	"quickLinkTitle": `Dashboard-quickLinkTitle-eX4U2`,
	"quickLinkDesc": `Dashboard-quickLinkDesc-w6n5P`,
	"quickLinkArrow": `Dashboard-quickLinkArrow-FoubV`,
	"quickLinkArrowGreen": `Dashboard-quickLinkArrowGreen-Utudd`,
	"messagesSection": `Dashboard-messagesSection-_bpZ0`,
	"messagesSectionHeader": `Dashboard-messagesSectionHeader-agRXE`,
	"viewAllLink": `Dashboard-viewAllLink-ACLXj`,
	"viewAllChevron": `Dashboard-viewAllChevron-tzS6l`,
	"helpSection": `Dashboard-helpSection-BAYbq`,
	"helpIllustration": `Dashboard-helpIllustration-xsNNO`,
	"helpImage": `Dashboard-helpImage-HXesk`,
	"helpContent": `Dashboard-helpContent-MGSXM`,
	"helpTitle": `Dashboard-helpTitle-Is4NG`,
	"helpText": `Dashboard-helpText-T0a_c`,
	"helpArrow": `Dashboard-helpArrow-SI9Rk`,
	"helpChevron": `Dashboard-helpChevron-MbCXO`,
	"leftColumn": `Dashboard-leftColumn-K2Fc1`,
	"sideNavWrapper": `Dashboard-sideNavWrapper-beK85`,
	"sideNavList": `Dashboard-sideNavList-B0TAB`,
	"sideNavItem": `Dashboard-sideNavItem-ZXHVM`,
	"sideNavItemActive": `Dashboard-sideNavItemActive-gi2aN`,
	"sideNavIcon": `Dashboard-sideNavIcon-Dx6lA`,
	"sideNavIconImg": `Dashboard-sideNavIconImg-LgHnY`,
	"sideNavLabel": `Dashboard-sideNavLabel-p5Dhn`,
	"rightColumn": `Dashboard-rightColumn-jvjCp`,
	"belowBannerGrid": `Dashboard-belowBannerGrid-nZ3al`,
	"profileColumn": `Dashboard-profileColumn-zjdP5`,
	"mainColumn": `Dashboard-mainColumn-Vg5kB`,
	"profileUserInfo": `Dashboard-profileUserInfo-_gVS9`,
	"profileUserName": `Dashboard-profileUserName-Orbgt`,
	"profileUserLocation": `Dashboard-profileUserLocation-XYGj8`,
	"profileLocationPin": `Dashboard-profileLocationPin-EIu0W`,
	"dashboardNoteCard": `Dashboard-dashboardNoteCard-a_HdL`,
	"dashboardNoteIconWrap": `Dashboard-dashboardNoteIconWrap-PTJ5E`,
	"dashboardNoteIcon": `Dashboard-dashboardNoteIcon-zYr33`,
	"dashboardNoteContent": `Dashboard-dashboardNoteContent-hcNLh`,
	"dashboardNoteTitle": `Dashboard-dashboardNoteTitle-gtohv`,
	"dashboardNoteText": `Dashboard-dashboardNoteText-ZboyH`,
	"dashboardNoteGreetingBold": `Dashboard-dashboardNoteGreetingBold-QrBTz`
};
module.exports = ___CSS_LOADER_EXPORT___;
